export function downloadEncodedDocument({
  mimetype,
  encodedDocument,
  filename,
}: {
  encodedDocument: string;
  filename: string;
  mimetype: string;
}) {
  const linkSource = `data:${mimetype};base64,${encodedDocument}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = filename;
  downloadLink.click();
}
